import type { Character } from "~/types/ip";
import type { CtaLink, SynopsisData } from "@laftel-ip-originals/notion/contracts";

import seeingdoubleCharacters from "~/data/seeingdouble/characters.json";
import seeingdoubleSynopsis from "~/data/seeingdouble/synopsis.json";
import seeingdoubleCtaLinks from "~/data/seeingdouble/cta-links.json";

interface IpPageData {
  characters: Character[];
  synopsis: SynopsisData;
  ctaLinks: CtaLink[];
}

const PAGE_DATA: Partial<Record<string, IpPageData>> = {
  seeingdouble: {
    characters: seeingdoubleCharacters as unknown as Character[],
    synopsis: seeingdoubleSynopsis as unknown as SynopsisData,
    ctaLinks: seeingdoubleCtaLinks as unknown as CtaLink[],
  },
};

export function getIpPageData(slug: string | undefined): IpPageData | null {
  return slug ? (PAGE_DATA[slug] ?? null) : null;
}
